// import React from "react";

// const LifeGrid = ({ weeksLeft }) => {
//   const totalYears = 60;
//   const weeksPerYear = 52;
//   const passedWeeks = totalYears * weeksPerYear - weeksLeft;

//   return (
//     <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 mt-8 px-4">
//       {[...Array(totalYears)].map((_, yearIndex) => (
//         <div
//           key={yearIndex}
//           className="border border-gray-500 p-2 rounded-lg shadow-md bg-gradient-to-b from-gray-900 to-gray-800"
//         >
//           <div className="text-center text-xs sm:text-sm font-bold text-white mb-3">
//             Year {yearIndex + 1}
//           </div>
//           {/* Adjust grid for smaller screens */}
//           <div className="grid grid-cols-6 sm:grid-cols-8 md:grid-cols-13 gap-1">
//             {[...Array(weeksPerYear)].map((_, weekIndex) => {
//               const weekNumber = yearIndex * weeksPerYear + weekIndex;
//               return (
//                 <div
//                   key={weekIndex}
//                   className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full ${
//                     weekNumber < passedWeeks
//                       ? "bg-red-500"
//                       : "bg-gray-300"
//                   } hover:bg-green-700 transition-colors duration-200`}
//                   title={`Week ${weekNumber + 1} - ${
//                     weekNumber < passedWeeks ? "Passed" : "Remaining"
//                   }`}
//                 />
//               );
//             })}
//           </div>
//         </div>
//       ))}
//     </div>
//   );
// };

// export default LifeGrid;




import React from "react";

const LifeGrid = ({ weeksLeft }) => {
  const totalYears = 60;
  const weeksPerYear = 52;
  const passedWeeks = totalYears * weeksPerYear - weeksLeft;

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-4 mt-8 px-4">
      {[...Array(totalYears)].map((_, yearIndex) => (
        <div
          key={yearIndex}
          className="border border-gray-500 p-2 rounded-lg shadow-md bg-gradient-to-b from-gray-900 to-gray-800"
        >
          <div className="text-center text-xs sm:text-sm font-bold text-white mb-3">
            Year {yearIndex + 1}
          </div>
          {/* Adjust grid for smaller screens */}
          <div className="grid grid-cols-6 sm:grid-cols-8 md:grid-cols-13 gap-1">
            {[...Array(weeksPerYear)].map((_, weekIndex) => {
              const weekNumber = yearIndex * weeksPerYear + weekIndex;
              return (
                <div
                  key={weekIndex}
                  className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full ${
                    weekNumber < passedWeeks
                      ? "bg-red-500"
                      : "bg-gray-300"
                  } hover:bg-green-700 transition-colors duration-200`}
                  title={`Week ${weekNumber + 1} - ${
                    weekNumber < passedWeeks ? "Passed" : "Remaining"
                  }`}
                />
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default LifeGrid;
